import {getSuccessOnlyResponseStatus} from '../../core-utilities/redux-request/utils';
import {logger} from './logger';

export const baseReduxRequestOptions = {
  getResponseStatus: getSuccessOnlyResponseStatus,
  autoReset: 3500,
  logger,
};



// WEBPACK FOOTER //
// ./src/js/auth/redux/requests.js